import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SearchResult, getUrlParams } from 'src/app/shared';
import {
  CertificationDetails,
  PreviousCertifications,
} from 'src/app/shared/models/CertificationDetails';
import { TimelineItem } from '../../models/Timeline';
import { ClaimService } from '../../services/claim.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-certifications',
    template: `
    <div class="app-pb1">
      <app-custom-message
        [listClientMessage]="this.claim?.listClientMessage"
        [keyForMessage]="'Certifications'"
        >
      </app-custom-message>
      <div class="header app-pt2">
        {{ 'Remember, multiple certifications may exist for each claim.' | translation : translationRequest }}
        <br />{{ 'The current status of this leave is based on the most recent certification received from the treatment provider as shown below.' | translation : translationRequest }}
      </div>
    
      <app-loading-panel [state]="!isLoaded ? 'Loading' : 'Loaded'">
      </app-loading-panel>
      @if (isLoaded) {
        <div>
          @if (showIllness) {
            <div
              class="app-pt3 app-pb2 tw-flex tw-flex-wrap tw-w-full"
              >
              <div class="app-header-3 tw-py-2 tw-w-full col-black">
                {{ examinerDisplayText | translation : translationRequest }}
              </div>
              <ng-container>
                <div class="tw-grid tw-grid-cols-[150px_auto] tw-py-2">
                  @if (
                    (this.incapacityFrequency !== null &&
                    this.incapacityFrequency !== undefined &&
                    this.incapacityFrequency !== '' &&
                    this.claim.source === 'L') ||
                    this.claim.source !== 'L'
                    ) {
                    <div class="app-label font-size-11">{{ 'ILLNESS' | translation : translationRequest }}</div>
                    <div>{{ incapacityFrequency | translation : translationRequest}}</div>
                  }
                  @if (
                    (this.treatmentFrequency !== null &&
                    this.treatmentFrequency !== undefined &&
                    this.treatmentFrequency !== '' &&
                    this.claim.source === 'L') ||
                    this.claim.source !== 'L'
                    ) {
                    <div class="app-label  font-size-11">{{ 'APPOINTMENT' | translation : translationRequest }}</div>
                    <div>
                      {{ treatmentFrequency | translation : translationRequest}}
                    </div>
                  }
                </div>
              </ng-container>
            </div>
          }
          <div class="app-header-3 tw-py-2 col-black">
            <h3>{{ 'Certifications' | translation : translationRequest }}</h3>
          </div>
          @if (this.timelineDetails && this.timelineDetails.length > 0) {
            <div>
              <div class="header app-pt1">
                {{ 'The certification(s) below are related to your' | translation : translationRequest }}
                {{ reason | translation : translationRequest }} {{ 'for your' | translation : translationRequest }} {{ relationship | translation : translationRequest }}
              </div>
              <span>
                <label><b>{{ 'Status' | translation : translationRequest }}</b></label>
                <label
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                  this.currentCertificationStatus | translation : translationRequest
                  }}</label
                  >
                </span>
              </div>
            }
            @if (this.timelineDetails && this.timelineDetails.length > 0) {
              <div
                class="app-pt3 app-pb2 tw-flex tw-flex-wrap tw-w-full"
                >
                <ng-container>
                  <div class="line tw-w-full app-mt2 app-pt2"></div>
                  <app-claim-timeline
                    class="tw-w-full"
                    [source]="source"
                    [claimId]="claimId"
                    [lob]="claim?.lob"
                    [claim]="claim"
                    [isFromCertifications]="true"
                    [tracker]="timelineDetails"
                    [translationRequest]="translationRequest"
                  ></app-claim-timeline>
                </ng-container>
              </div>
            }
            @if (!(this.timelineDetails && this.timelineDetails.length > 0)) {
              <div>
                <div class="header app-pt1">
                  <h3>{{ 'Current Certification' | translation : translationRequest }}</h3>
                </div>
                <div
                  class="tw-flex tw-flex-col tw-items-center"
                  style="color: var(--sed-black-60-color);"
                  >
                  <div>
                    <mat-icon class="material-symbols-outlined icon-md">
                      medical_information
                    </mat-icon>
                  </div>
                  <div class="tagline-header app-pt1 app-pb1 ">
                    <strong>{{ 'No current certifications' | translation : translationRequest }}</strong>
                  </div>
                </div>
              </div>
            }
            <div>
              @if (
                this.previousCertifications &&
                this.previousCertifications.length > 0
                ) {
                <mat-slide-toggle
                  (change)="showPrevious($event.checked)"
                  >
                  <span class="font-style-authPref"
                    ><b>{{ 'Show previous certifications' | translation : translationRequest }}</b>
                  </span>
                </mat-slide-toggle>
              }
            </div>
            @if (
              showPreviousCerts &&
              this.previousCertifications &&
              this.previousCertifications.length > 0
              ) {
              <div
                >
                <app-list
                  [dataSource]="previousCertifications"
                  [template]="row"
                  class="app-pt2"
                  [exportEnabled]="false"
                  [paginatorEnabled]="true"
                  [paginatorTemplate]="certificatonPagination"
                  noDataIcon="monetization_on"
                  [tableAriaLabel]="'Certifications'"
                  >
                  <ng-container header>
                    <tr class="tw-flex tw-flex-wrap tw-w-full">
                      <app-list-header
                        name="beginDate"
                        label="date range"
                        class="tw-w-[20%]"
                      ></app-list-header>
                      <app-list-header
                        name="status"
                        label="Status"
                        class="tw-w-[15%]"
                      ></app-list-header>
                      <app-list-header
                        name="subStatus"
                        label="sub status"
                        class="tw-w-[15%]"
                      ></app-list-header>
                      <app-list-header
                        name="dateSent"
                        label="details"
                        class="tw-w-[17%]"
                      ></app-list-header>
                      <app-list-header
                        name="clarificationRequested"
                        label="clarification requested"
                        class="tw-w-[17%]"
                      ></app-list-header>
                      <app-list-header
                        name="clarificationSent"
                        label="clarification details"
                        class="tw-w-[16%]"
                      ></app-list-header>
                    </tr>
                  </ng-container>
                </app-list>
                <ng-template #row let-element>
                  <tr class="tw-flex tw-flex-wrap tw-w-full tw-items-center">
                    <td class="tw-w-full md:tw-w-[20%]">
                      <app-value
                        label="date range"
                        layout="row-xs"
                        [tabindex]="0"
                  [value]="
                    (element.beginDate === undefined
                      ? ''
                      : (element.beginDate | format : 'date') + ' - ') +
                    (element.endDate === undefined
                      ? ''
                      : (element.endDate | format : 'date'))
                  "
                        [translationNeeded]="false"
                        >
                      </app-value>
                    </td>
                    <td class="tw-w-full md:tw-w-[15%]">
                      <app-value
                        label="status"
                        [tabindex]="0"
                        layout="row-xs"
                        [value]="element.status"
                        >
                      </app-value>
                    </td>
                    <td class="tw-w-full md:tw-w-[15%]">
                      <app-value
                        label="sub status"
                        [tabindex]="0"
                        layout="row-xs"
                        [value]="element.subStatus"
                        >
                      </app-value>
                    </td>
                    <td class="tw-w-full md:tw-w-[17%] ">
                      @if (element.dateSent) {
                        <app-value
                          layout="row"
                          [tabindex]="0"
                          label="SENT"
                          ngClass="tw-w-full"
                          [value]="element.dateSent | format : 'date'"
                          [translationNeeded]="false"
                        ></app-value>
                      }
                      @if (element.dateReceived) {
                        <app-value
                          layout="row"
                          label="RECEIVED"
                          ngClass="tw-w-full"
                          [tabindex]="0"
                          [value]="element.dateReceived | format : 'date'"
                          [translationNeeded]="false"
                        ></app-value>
                      }
                      @if (element.dateReviewed) {
                        <app-value
                          layout="row"
                          label="REVIEWED"
                          ngClass="tw-w-full"
                          [tabindex]="0"
                          [value]="element.dateReviewed | format : 'date'"
                          [translationNeeded]="false"
                        ></app-value>
                      }
                      @if (element.dateDue) {
                        <app-value
                          layout="row"
                          ngClass="tw-w-full"
                          [tabindex]="0"
                          label="DUE"
                          [value]="element.dateDue | format : 'date'"
                          [translationNeeded]="false"
                        ></app-value>
                      }
                    </td>
                    <td class="tw-w-full md:tw-w-[17%]">
                      <app-value
                        label="clarification requested"
                        layout="row-xs"
                        [tabindex]="0"
                        [value]="element.clarificationRequested"
                        >
                      </app-value>
                    </td>
                    <td class="tw-w-full md:tw-w-[16%] ">
                      @if (element.clarificationRequested === 'Yes') {
                        <div>
                          @if (element.clarificationSent) {
                            <app-value
                              layout="row"
                              label="SENT"
                              [tabindex]="0"
                              [value]="element.clarificationSent | format : 'date'"
                              [translationNeeded]="false"
                            ></app-value>
                          }
                          @if (element.clarificationReceived) {
                            <app-value
                              layout="row"
                              label="RECEIVED"
                              [tabindex]="0"
                              [value]="element.clarificationReceived | format : 'date'"
                              [translationNeeded]="false"
                            ></app-value>
                          }
                          @if (element.clarificationReviewed) {
                            <app-value
                              layout="row"
                              label="REVIEWED"
                              [tabindex]="0"
                              [value]="element.clarificationReviewed | format : 'date'"
                            ></app-value>
                          }
                          @if (element.clarificationDue) {
                            <app-value
                              layout="row"
                              label="DUE"
                              [tabindex]="0"
                              [value]="element.clarificationDue | format : 'date'"
                              [translationNeeded]="false"
                            ></app-value>
                          }
                          @if (element.clarificationType) {
                            <app-value
                              layout="row"
                              [tabindex]="0"
                              label="TYPE"
                              [value]="element.clarificationType"
                            ></app-value>
                          }
                        </div>
                      }
                    </td>
                  </tr>
                </ng-template>
                <ng-template #certificatonPagination>
                  <div
                    class="inlineBlock"
                    #tooltip="matTooltip"
                    [matTooltip]=""
                    matTooltipPosition="below"
                    (mouseenter)="$event.stopImmediatePropagation()"
                    (mouseleave)="$event.stopImmediatePropagation()"
                    (click)="tooltip.toggle()"
                  ></div>
                </ng-template>
              </div>
            }
          </div>
        }
      </div>
    `,
    styles: [
        `
      .header {
        font-weight: bold;
      }
      .col-black {
        color: #171c20 !important;
      }
      .icon-md {
        font-size: 60px;
        width: 60px;
        height: 60px;
      }
      .font-size-11 {
        font-size: 11px !important;
        font-weight: 700 !important;
      }
    `,
    ],
    standalone: false
})
export class CertificationsComponent implements OnInit {
  certifications$ = new BehaviorSubject([]);
  certification: CertificationDetails;
  previousCertifications: PreviousCertifications[];
  showIllness: boolean = false;
  showPreviousCerts: boolean = false;
  timelineDetails: TimelineItem[];
  source: string;
  iconColor = 'var(--color-slate)';
  @Input()
  claim: SearchResult;
  claimId: string;
  currentCertificationStatus: string;
  treatmentFrequency: string;
  incapacityFrequency: string;
  examinerDisplayText: string;
  relationship: string;
  isLoaded: boolean = false;
  reason: string;
  @Input()
  translationRequest: TranslationRequest;
  constructor(public claimService: ClaimService) {}
  async ngOnInit() {
    if (this.claim?.isIntermittent) {
      this.showIllness = true;
    }

    //let claimNumber = 'C310180257300004TC';
    const params = getUrlParams();
    this.source = params.source;
    this.claimId = params.claimId;
    const result = await this.claimService.getCertifications(
      this.claim.claimNumber,
      this.source,
      this.claimId,
      this.claim.lob
    );
    this.isLoaded = true;
    if (result) {
      this.currentCertificationStatus = result.currentCrertificateStatus;
      this.treatmentFrequency = result.treatmentFrequency;
      this.incapacityFrequency = result.incapacityFrequency;
      this.examinerDisplayText = result.examinerDisplayText;

      this.relationship = result.relationship;
      if (
        result.previousCertifications &&
        result.previousCertifications.length > 0
      ) {
        this.previousCertifications = result.previousCertifications;
      }
      if (
        result.currentCertificationTimeline &&
        result.currentCertificationTimeline.length > 0
      ) {
        this.timelineDetails = result.currentCertificationTimeline;
      }
    }
    if (this.claim?.type && this.claim.source !== 'L') {
      this.reason = this.claim.type;
    } else if (this.claim?.claimDescription && this.claim.source !== 'L') {
      this.reason = this.claim.claimDescription;
    } else {
      this.reason = result.reason;
    }
  }

  showPrevious(show: boolean) {
    this.showPreviousCerts = show;
  }
}
